export default "__VITE_ASSET__Dgcf_gdD__"